import upload from './upload';
import UUID from './uuid';

export default {
  upload,
  UUID,

  rgbaTo16(color) {
    let obj = {};
    let arr = color.replace('rgba(', '').replace(')', '').split(',');
    let r = parseInt(arr[0]);
    let g = parseInt(arr[1]);
    let b = parseInt(arr[2]);
    let hex = ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    obj.color = `0x${hex}`;
    obj.opacity = arr[3];
    return obj;
  },

  isMobile() {
    let ua = navigator.userAgent;

    let ipad = !!ua.match(/(iPad).*OS\s([\d_]+)/),
      isIphone = !ipad && !!ua.match(/(iPhone\sOS)\s([\d_]+)/),
      isAndroid = !!ua.match(/(Android)\s+([\d.]+)/),
      isMobile = isIphone || isAndroid;

    return isMobile;
  },
  requestAnimationFrame: require('./requestAnimationFrame.js').requestAnimationFrame,
  cancelAnimationFrame: require('./requestAnimationFrame.js').cancelAnimationFrame,
};
